var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('main-header-plat-a-pat'),_c('main-header-plat-b',{attrs:{"navBItems":_vm.schema.navBItems}}),_c('v-overlay-loader'),_c('v-row',{staticClass:"mx-auto"},[_c('v-inbox')],1),_c('v-snack-bar',{attrs:{"snackbar":_vm.snackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }